import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-goods-and-services-dialog',
  templateUrl: './goods-and-services-dialog.component.html',
  styleUrls: ['./goods-and-services-dialog.component.scss'],
  standalone: false,
})
export class GoodsAndServicesDialogComponent {
  private data = inject(MAT_DIALOG_DATA);

  trademarkName!: string;
  goodsAndServices!: string;
  constructor() {
    this.trademarkName = this.data.trademarkName;
    this.goodsAndServices = this.data.goodsAndServices;
  }
}
